export default function ScrollablePanelCSS ()
{
  this.create = (win) =>
  {
    if (BEditor.domHelpers.$('idBonaEditorScrollablePanelStyles', win))
    {
      return true;
    }

    const style = win.document.createElement('STYLE');

    style.setAttribute('id', 'idBonaEditorScrollablePanelStyles');
    style.innerHTML = `
      DIV.editorScrollablePanelContainer
      {
        position: relative;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollablePanelWrapper
      {
       overflow: hidden;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollablePanelWrapper ::-webkit-scrollbar,
      DIV.editorScrollablePanelContainer DIV.editorScrollablePanelWrapper ::-webkit-scrollbar-button,
      DIV.editorScrollablePanelContainer DIV.editorScrollablePanelWrapper ::-webkit-scrollbar-track,
      DIV.editorScrollablePanelContainer DIV.editorScrollablePanelWrapper ::-webkit-scrollbar-track-piece,
      DIV.editorScrollablePanelContainer DIV.editorScrollablePanelWrapper ::-webkit-scrollbar-thumb,
      DIV.editorScrollablePanelContainer DIV.editorScrollablePanelWrapper ::-webkit-scrollbar-corner,
      DIV.editorScrollablePanelContainer DIV.editorScrollablePanelWrapper ::-webkit-resizer
      {
        width: 0;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer, DIV.editorScrollablePanelContainer DIV.editorScrollBarSlider
      {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAABCAMAAAC1xj0zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAFFQTFRFysrK39/fxMTEtbW12tra9vb26+vroqKi5ubmlpaW0NDQwcHB4ODg29vb1NTU4+Pj/f397u7ut7e38fHx4eHh3d3d8vLy+vr65+fnz8/P7e3tunUk0AAAADhJREFUeNpi4OZiYQQDFnZmJgYwYEKwhFgFxFnFBNlYJTk5hKUkeFj4OJg52Vh4RRlF+NmYAQIMACUMAa+nFZs1AAAAAElFTkSuQmCC);
        background-repeat: repeat-y;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer
      {
        position: absolute;
        right: 0;
        top: 0;
        width: 10px;
        overflow: hidden;
        background-color: #DFDFDF;
        cursor: default;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer DIV.editorScrollBarTop,
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer DIV.editorScrollBarBottom,
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer DIV.editorScrollBarSliderTop,
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer DIV.editorScrollBarSliderMiddle,
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer DIV.editorScrollBarSliderBottom
      {
        position: absolute;
        left: 0;
        width: 10px;
        overflow: hidden;
        background-color: transparent;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAATCAMAAACwcE1OAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQhQTFRF////ysrK39/fxMTEtbW12tra9vb26+vroqKi5ubmlpaW0NDQwcHB4ODg29vb1NTU4+Pj/f397u7ut7e38fHx4eHh3d3d8vLy+vr65+fnz8/P7e3txcXFzMzMp6enwMDAw8PDxsbGpaWlj4+Pvb295eXlurq6oaGh+/v7uLi40tLStLS0u7u7vr6+0dHRnZ2doKCgmJiY1tbWl5eXjIyMjY2Nzc3N2NjYi4uLwsLCubm5lJSUkJCQ8PDwv7+/3Nzc+fn59/f37Ozs1dXVm5ubqKio7+/vpqamlZWVtra2o6Oj4uLinp6empqazs7On5+fsbGxvLy819fXqqqq2dnZrKysyMjI////b2CjvQAAAFh0Uk5T////////////////////////////////////////////////////////////////////////////////////////////////////////////////////AHibwggAAAEqSURBVHjaxJDrVoJAFEaPw2UckYsomqnhDRQwFLuYllJappWW3Xj/NwkGjdUTtP/MXmev+fPBLsvsue80TyjNxCArcIjCpVkmRWESA92e8yGV0XYwGWqEaO9jZ2ByBsaGVHdgV+ge8SV1WbI3ojovixKnrTcGKhbRMyFrmPC5KGNe8EihUhY5meQ9zElFpCk4D9ZvXh2yszpkB4IgiHJAiXJsUQ6fKF+mGvX4eHbduort/KJ1s8+57u1dfISQP/avv60lXU2dChkUryayGQX54WqGwcLkexptPnVd72OLCEFu3vK+bAVjRbYsaGdnpyH14+HLU3rQ778+srPEQK+5C1leDKXPzpvZ7vXaenWcGFRtX6T4D2ajRmkkBowwkiijJqtXKXpiPwIMAEGFW/e/LsLPAAAAAElFTkSuQmCC);
        background-repeat: no-repeat;
        cursor: default;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer DIV.editorScrollBarTop, DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer DIV.editorScrollBarBottom
      {
        height: 2px;
        z-index: 4;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer DIV.editorScrollBarTop
      {
        top: 0;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer DIV.editorScrollBarBottom
      {
        bottom: 0;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer DIV.editorScrollBarSlider
      {
        position: absolute;
        left: 0;
        top: 1px;
        width: 10px;
        overflow: hidden;
        background-color: #F7F7F7;
        cursor: default;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer DIV.editorScrollBarSliderTop,
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer DIV.editorScrollBarSliderMiddle,
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer DIV.editorScrollBarSliderBottom
      {
        z-index: 7;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer DIV.editorScrollBarSliderTop,
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer DIV.editorScrollBarSliderBottom
      {
        height: 4px;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer DIV.editorScrollBarSliderTop
      {
        top: 0;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer DIV.editorScrollBarSliderMiddle
      {
        height: 8px;
        top: 50%;
        margin-top: -4px;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainer DIV.editorScrollBarSliderBottom
      {
        bottom: 0;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerNormal
      {
        background-position: 0 0;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerNormal DIV.editorScrollBarTop
      {
        background-position: 0 0;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerNormal DIV.editorScrollBarBottom
      {
        background-position: 0 -17px;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerNormal DIV.editorScrollBarSlider
      {
        background-position: -30px 0;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerNormal DIV.editorScrollBarSliderTop
      {
        background-position: 0 -2px;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerNormal DIV.editorScrollBarSliderMiddle
      {
        background-position: 0 -6px;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerNormal DIV.editorScrollBarSliderBottom
      {
        background-position: 0 -13px;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerOver
      {
        background-position: -10px 0;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerOver DIV.editorScrollBarTop
      {
        background-position: -10px 0;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerOver DIV.editorScrollBarBottom
      {
        background-position: -10px -17px;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerOver DIV.editorScrollBarSlider
      {
        background-position: -40px 0;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerOver DIV.editorScrollBarSliderTop
      {
        background-position: -10px -2px;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerOver DIV.editorScrollBarSliderMiddle
      {
        background-position: -10px -6px;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerOver DIV.editorScrollBarSliderBottom
      {
        background-position: -10px -13px;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerActive
      {
        background-position: -20px 0;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerActive DIV.editorScrollBarTop
      {
        background-position: -20px 0;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerActive DIV.editorScrollBarBottom
      {
        background-position: -20px 0;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerActive DIV.editorScrollBarSlider
      {
        background-position: -50px 0;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerActive DIV.editorScrollBarSliderTop
      {
        background-position: -20px -2px;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerActive DIV.editorScrollBarSliderMiddle
      {
        background-position: -20px -6px;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollBarContainerActive DIV.editorScrollBarSliderBottom
      {
        background-position: -20px -13px;
      }
      DIV.editorScrollablePanelContainer DIV.editorScrollablePanelContentContainer
      {
        overflow-x: hidden;
        overflow-y: scroll;
        visibility: hidden;
      }
      DIV.editorScrollablePanelContainerBorder
      {
        border: 1px solid #C4C4C4;
        border-right-color: #DBDBDB;
        border-bottom-color: #DBDBDB;
        border-radius: 2px;
      }`;

    win.document.querySelector('HEAD').appendChild(style);
  }
}